module.exports = __webpack_public_path__ + "img/p14.daa08f4e.png";